<template>
  <div class="nav flex-ac">
    <span class="position">您的位置：</span>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in navList"
        :key="index"
        :to="item.url != '' ? { path: item.url } : ''"
        >{{ item.name }}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "breadCrumb",
  data() {
    return {};
  },
  props: {
    navList: {
      default: [],
      type: Array,
    },
  },
  computed: {},
  watch: {},
  activated() {},
  deactivated() {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.nav {
  padding: 20px 0 48px;
}
.position {
  color: #707070;
  font-size: 16px;
}
/deep/ .el-breadcrumb {
  font-size: 16px !important;
}
/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: @mainColor !important;
  font-weight: bold;
}
/deep/ .el-breadcrumb__inner a:hover,
/deep/ .el-breadcrumb__inner.is-link:hover {
  color: @mainColor !important;
}
/deep/ .el-breadcrumb__inner a,
/deep/ .el-breadcrumb__inner.is-link {
  font-weight: 400 !important;
  color: #000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/breadCrumb.vue